// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__TEGNo","titleBlock":"Advt_titleBlock__IMUgQ","title":"Advt_title__eiQQ0","qrsWrapper":"Advt_qrsWrapper__-t9WX","qrCode":"Advt_qrCode__7ziX+"};